"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _ProviderCard = _interopRequireDefault(require("../ProviderCard"));
var _ProviderCardV = _interopRequireDefault(require("../ProviderCardV2"));
var _ProviderCardEmpty = _interopRequireDefault(require("./components/ProviderCardEmpty"));
var _ProviderCardLoading = _interopRequireDefault(require("./components/ProviderCardLoading"));
var _ProviderSelectPaginationLoader = _interopRequireDefault(require("./components/ProviderSelectPaginationLoader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ProviderSelect = /*#__PURE__*/function (_Component) {
  _inherits(ProviderSelect, _Component);
  var _super = _createSuper(ProviderSelect);
  function ProviderSelect(props) {
    var _this;
    _classCallCheck(this, ProviderSelect);
    _this = _super.call(this, props);
    _this.onAddProvider = _this.onAddProvider.bind(_assertThisInitialized(_this));
    _this.onRemoveProvider = _this.onRemoveProvider.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ProviderSelect, [{
    key: "onAddProvider",
    value: function onAddProvider(provider) {
      var _this$props$input = this.props.input,
        onChange = _this$props$input.onChange,
        value = _this$props$input.value;
      var originalValue = value === '' ? [] : value;
      var newValue = (0, _lodash.concat)(originalValue, provider);
      onChange(newValue);
    }
  }, {
    key: "onRemoveProvider",
    value: function onRemoveProvider(provider) {
      var _this$props$input2 = this.props.input,
        onChange = _this$props$input2.onChange,
        value = _this$props$input2.value;
      var originalValue = value === '' ? [] : value;
      var newValue = (0, _lodash.filter)(originalValue, function (val) {
        return val.id !== provider.id;
      });
      onChange(newValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        ccGroupIds = _this$props.ccGroupIds,
        id = _this$props.id,
        input = _this$props.input,
        isLoading = _this$props.isLoading,
        isReferral = _this$props.isReferral,
        meta = _this$props.meta,
        onDetailClick = _this$props.onDetailClick,
        onLoadMore = _this$props.onLoadMore,
        openLink = _this$props.openLink,
        options = _this$props.options,
        originLatLng = _this$props.originLatLng,
        paging = _this$props.paging,
        renderPaginationLoader = _this$props.renderPaginationLoader,
        selectedServiceType = _this$props.selectedServiceType,
        v2Flag = _this$props.v2Flag;
      var hasError = meta.invalid && meta.touched;
      var containerClass = function containerClass() {
        return (0, _classnames["default"])({
          'ui-form-field': true,
          'ui-form-field--has-error': hasError
        });
      };
      var selectedProviders = input.value;
      var hasSelection = selectedProviders.length > 0;
      // Potentially high time complexity operation?
      var hasCCSelected = (0, _lodash.some)(selectedProviders, function (provider) {
        return (0, _lodash.some)(ccGroupIds, function (ccId) {
          return provider.id === ccId;
        });
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: containerClass(),
        id: id
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-provider-select"
      }, isLoading && (0, _lodash.isEmpty)(options) && !renderPaginationLoader && /*#__PURE__*/_react["default"].createElement(_ProviderCardLoading["default"], null), !(0, _lodash.isEmpty)(options) && (!isLoading || renderPaginationLoader) && /*#__PURE__*/_react["default"].createElement("div", {
        onBlur: input.onBlur,
        onFocus: input.onFocus,
        className: "ui-provider-select-cards"
      }, options.map(function (provider) {
        var isCC = (0, _lodash.includes)(ccGroupIds, provider.id);
        var isSelected = (0, _lodash.findIndex)(selectedProviders, function (val) {
          return val.id === provider.id;
        }) >= 0;
        var disableSelection = !isSelected && (
        // Only prevent selection if the item is not already selected
        !isCC && hasSelection && hasCCSelected // Item is non-CC and some CC is already selected
        || isCC && hasSelection // Item is CC and another item is selected
        );
        if (v2Flag) {
          return /*#__PURE__*/_react["default"].createElement(_ProviderCardV["default"], {
            disableSelection: disableSelection,
            isSelected: isSelected,
            key: provider.id,
            onAddProvider: _this2.onAddProvider,
            openLink: openLink,
            onDetailClick: onDetailClick,
            onRemoveProvider: _this2.onRemoveProvider,
            originLatLng: originLatLng,
            provider: provider,
            selectedServiceType: selectedServiceType
          });
        }
        return /*#__PURE__*/_react["default"].createElement(_ProviderCard["default"], {
          disableSelection: disableSelection,
          isSelected: isSelected,
          key: provider.id,
          onAddProvider: _this2.onAddProvider,
          onDetailClick: onDetailClick,
          onRemoveProvider: _this2.onRemoveProvider,
          originLatLng: originLatLng,
          provider: provider,
          selectedServiceType: selectedServiceType
        });
      })), !isLoading && (0, _lodash.isEmpty)(options) && /*#__PURE__*/_react["default"].createElement(_ProviderCardEmpty["default"], null), renderPaginationLoader && /*#__PURE__*/_react["default"].createElement(_ProviderSelectPaginationLoader["default"], {
        isFetching: isLoading,
        isReferral: isReferral,
        onLoadMore: onLoadMore,
        paging: paging
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-form-field__error"
      }, meta.error));
    }
  }]);
  return ProviderSelect;
}(_react.Component);
ProviderSelect.propTypes = {
  /** Array of group ids identified as coordination centers */
  ccGroupIds: _propTypes["default"].array,
  /** ID for the component */
  id: _propTypes["default"].string.isRequired,
  /** input prop passed by Redux-form */
  input: _propTypes["default"].object.isRequired,
  /** display loading bar */
  isLoading: _propTypes["default"].bool,
  /** indicates Referral Workflow */
  isReferral: _propTypes["default"].bool,
  /** meta prop passed by Redux-form */
  meta: _propTypes["default"].object.isRequired,
  /**
   * callback when the detail card is clicked
   * @param {object} provider
  */
  onDetailClick: _propTypes["default"].func,
  /** callback when the "Load More" button is clicked */
  onLoadMore: _propTypes["default"].func,
  /** called to open link with AGL protocol */
  openLink: _propTypes["default"].func,
  /** array of providers */
  options: _propTypes["default"].array,
  /** origin lat_lng array used to calculate distance to provider location */
  originLatLng: _propTypes["default"].array,
  /** object prop for paging information */
  paging: _propTypes["default"].object,
  /** shows "Load More" if ProviderSelectPaginationLoader prop is passed */
  renderPaginationLoader: _propTypes["default"].bool,
  /** the current service type(s) to display on the card */
  selectedServiceType: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].arrayOf(_propTypes["default"].object)]),
  /** Temporary prop to display ProviderCardV2 component -- should remove after feature flag is removed */
  v2Flag: _propTypes["default"].bool
};
ProviderSelect.defaultProps = {
  ccGroupIds: [],
  isLoading: false,
  isReferral: false,
  onDetailClick: null,
  onLoadMore: _lodash.noop,
  openLink: window.open,
  options: [],
  originLatLng: [],
  paging: {},
  renderPaginationLoader: false,
  selectedServiceType: {},
  v2Flag: false
};
var _default = exports["default"] = ProviderSelect;